import React from 'react';
import _ from 'lodash';
import DDadosBase, { LabeledInput } from '@common/components/ddados/ddados.base';
import Field from '@common/components/validation/field.validation';
import { EditorToolsSettings } from '@progress/kendo-react-editor';
import RichTextComponent from '@common/components/richText/richText.component';

for (var key in EditorToolsSettings) {
  if (EditorToolsSettings[key].props) {
    EditorToolsSettings[key].props.type = 'button';
    EditorToolsSettings[key].props.className = 'form-control';
  }
}

class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);
    this.child = React.createRef();
  }

  renderComponent(viewEditor) {
    const { props } = this;

    return (
      <Field {...props}>
        {({ value, hasError, onChange, onChangeAsync, onBlur }) => {
          const newProps = {
            ...props,
            value,
            onChangeAsync,
            onChange,
            onBlur,
            ReadOnly: viewEditor ?? props.ReadOnly
          };
          
          return (
            <LabeledInput {...props}>
              <span className={`${hasError ? 'span-input-invalid' : ''}`}>
                <RichTextComponent ref={this.child} {...newProps} />
              </span>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderView() {
    return this.renderComponent(true);
  }
}

export default DDadosComponent;
